import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
function PointsRuleCard({
  direction = 'column',
  emoji,
  label,
  value
}) {
  if (direction === 'row') {
    return /*#__PURE__*/React.createElement(_Box, {
      alignItems: "center",
      display: "flex",
      gap: 2,
      padding: 3,
      sx: {
        background: '#FFF5D0',
        border: '1px solid #FFECA9',
        borderRadius: 4
      }
    }, emoji && /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 24
      }
    }, emoji), /*#__PURE__*/React.createElement(_Box, {
      flexGrow: 1
    }, /*#__PURE__*/React.createElement(_Typography, {
      fontWeight: 700
    }, label)), /*#__PURE__*/React.createElement(_Box, {
      flexShrink: 0
    }, /*#__PURE__*/React.createElement(_Typography, {
      noWrap: true,
      sx: {
        color: '#048760',
        fontWeight: 800
      }
    }, value)));
  }
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 1,
    minWidth: 120,
    padding: 2,
    sx: {
      background: '#FFF5D0',
      border: '1px solid #FFECA9',
      borderRadius: 4
    }
  }, emoji && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 32
    }
  }, emoji), /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    sx: {
      fontSize: 18,
      fontWeight: 700
    }
  }, label), /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    sx: {
      color: '#048760',
      fontSize: 24,
      fontWeight: 800
    }
  }, value));
}
export default PointsRuleCard;